export const DEFAULT_SITE_NAME = "Van Valve";
